const formatHoursAndMinutes = (date: Date) => {
  let hours = date.getHours() % 12;
  const minutes = date.getMinutes();
  const amPm = date.getHours() < 12 ? 'AM' : 'PM';
  if(hours === 0) hours = 12;

  const formattedHours = hours < 10 ? `0${hours}` : hours;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes} ${amPm}`;
};

export const formatNow = (timezone?: string) => {
  const now = new Date();
  if (timezone) {
    const options: any = {
      hour12: true,
      hour: 'numeric',
      minute: 'numeric',
      timeZone: timezone,
    };
    return now.toLocaleString('en-US', options);
  }
  return formatHoursAndMinutes(now);
};

export const formatTimeStamps = (timezone: string, timestamps: any) => {
  const date = new Date(timestamps + 'Z');

  const options: any = {
    hour12: true,
    hour: 'numeric',
    minute: 'numeric',
    timeZone: timezone,
  };
  return date.toLocaleString('en-US', options);
};
